<template>
  <div class="app-container">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="待发货订单" name="Todo"></el-tab-pane>
      <el-tab-pane label="已发货订单" name="Done"></el-tab-pane>
    </el-tabs>
    <order-todo ref="orderTodo" v-if="tabName == 'Todo'">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <div v-if="row.orderStatusDesc == '等待买家付款'">
              <el-button type="text" @click="modifyOrderPrice(row)">改价</el-button>
            </div>
            <div v-if="!row.isLock">
              <el-button type="text" @click="openPrint(row)">打印</el-button>
              <el-button type="text" @click="openPrintWithSend(row)">发货</el-button>
            </div>
            <div>
              <el-button type="text" v-if="!row.isLock" @click="setLockState(row, true)">锁定</el-button>
              <el-button type="text" v-else @click="setLockState(row, false)">解锁</el-button>
              <el-dropdown @command="selectFlag($event, row)" style="margin-left: 10px;">
                <el-button type="text">插旗</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="flag-red">
                    <div class="flag"><i class="el-icon-s-flag flag-red"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-orange">
                    <div class="flag"><i class="el-icon-s-flag flag-orange"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-yellow">
                    <div class="flag"><i class="el-icon-s-flag flag-yellow"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-green">
                    <div class="flag"><i class="el-icon-s-flag flag-green"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-blue">
                    <div class="flag"><i class="el-icon-s-flag flag-blue"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-indigo">
                    <div class="flag"><i class="el-icon-s-flag flag-indigo"></i></div>
                  </el-dropdown-item>
                  <el-dropdown-item command="flag-purple">
                    <div class="flag"><i class="el-icon-s-flag flag-purple"></i></div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <template v-if="row.isPrint">
              <div>
                <el-button type="text" @click="onUpdateExpressSheet(row)">更新面单</el-button>
              </div>
              <div>
                <el-button type="text" @click="onRecycle(row)">回收单号</el-button>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
    </order-todo>
    <order-done ref="orderDone" v-if="tabName == 'Done'">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="90">
          <template slot-scope="{row}">
            <div>
              <el-button type="text" @click="openPrint(row)">打印</el-button>
              <template v-if="row.orderStatusDesc == '已收货' || row.orderStatusDesc == '交易成功'">
                <el-button type="text" @click="submitRate(row)" :disabled="row.isSubmitRate">评价</el-button>
              </template>
            </div>
            <div>
              <el-button type="text" @click="onRecycle(row)">回收单号</el-button>
            </div>
            <div v-if="row.orderStatusDesc == '等待买家收货'">
              <el-button type="text" @click="postpone(row)">延迟收货</el-button>
            </div>
          </template>
        </el-table-column>
      </template>
    </order-done>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import orderTodo from "@/components/printandship/orderTodo/list";
import orderDone from "@/components/printandship/orderDone/list";

export default {
  name: "printandship",
  mixins: [curdMixins],
  components: {
    orderTodo,
    orderDone,
  },
  data() {
    return {
      tabName: "Todo"
    }
  },
  methods: {
    handleClick(e) {
      console.log("handleClick", e)
      this.$nextTick(() => {
        this.reload();
      });
    },
    reload() {
      this.$refs["order" + this.tabName].reload();
    },
    submitRate(row) {
      this.$refs["order" + this.tabName].submitRate(row);
    },
    postpone(row) {
      this.$refs["order" + this.tabName].postpone(row);
    },
    modifyOrderPrice(row) {
      this.$refs["order" + this.tabName].modifyOrderPrice(row);
    },
    openPrint(row) {
      this.$refs["order" + this.tabName].openPrint(row);
    },
    openPrintWithSend(row) {
      this.$refs["order" + this.tabName].openPrintWithSend(row);
    },
    selectFlag(command, row) {
      console.log("selectFlag", command, "row", row);
      // var data = { ids: row.multiorder.map(x => x.id), flag: command }
      // this.$refs["order" + this.tabName].selectFlag(data).then(res => {
      //   row.flag = command;
      //   row.multiorder.forEach(x => x.flag = command);
      //   this.$message.success("设置成功")
      // });
      row.flag = command;
      row.multiorder.forEach(x => x.flag = command);
      this.$message.success("设置成功")
    },
    //设置锁定状态，0：锁定，1：解锁
    setLockState(row, value) {
      var msg = "确定" + (value ? "锁定" : "解锁") + "此订单吗？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // var data = { ids: row.multiorder.map(x => x.id), isLock: value }
        // this.$refs["order" + this.tabName].setLock(data).then(res => {
        //   this.$message.success("设置成功");
        //   this.reload();
        // });
        this.$message.success("设置成功");
      }).catch(() => { });
    },
    //更新面单
    onUpdateExpressSheet(row) {
      this.$refs["order" + this.tabName].onUpdateExpressSheet(row);
    },
    onRecycle(row) {
      this.$refs["order" + this.tabName].onRecycle(row);
    },
  },
};
</script>
<style lang="scss">
.flag {
  width: 30px;
  font-size: 14px;
  text-align: center;

  i {
    margin: 0;
  }
}
</style>